var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoblue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 151,
    viewBox: "0 0 309 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.126 103.132H131.413C130.196 105.323 128.898 107.513 127.437 109.542C120.622 119.358 111.373 127.309 100.582 132.583C99.7712 132.989 98.9599 133.394 98.1485 133.719C89.6297 137.451 80.1372 139.56 70.2391 139.56C65.6957 139.56 61.1523 139.155 56.8523 138.262C57.0957 142.643 57.8259 146.943 58.9617 151C28.9429 140.372 6.38815 113.842 1.68249 81.4698C1.68249 81.3075 1.60136 81.1453 1.60136 81.0642C1.60136 80.983 1.60136 80.983 1.60136 80.9019C1.03344 77.3321 0.790039 73.7623 0.790039 70.0302C0.790039 69.7868 0.790039 69.4623 0.790039 69.2189V69.1377C0.952303 56.7245 4.27872 45.1226 10.1202 35.1434C10.2014 34.9811 10.2825 34.9 10.3636 34.7377C10.4448 34.4943 10.607 34.3321 10.6882 34.1698C22.858 13.9679 45.007 0.5 70.2391 0.5C98.3919 0.5 122.569 17.2132 133.522 41.2283H108.615C99.8523 29.5453 85.8976 22 70.158 22C43.6278 22 22.1278 43.5 22.1278 70.0302C22.1278 96.5604 43.6278 118.06 70.158 118.06C74.0523 118.06 77.8655 117.574 81.5165 116.681V116.6H81.841C90.9278 114.409 98.9599 109.704 105.126 103.132Z",
    fill: "#0077B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9741 55.1411C28.9741 54.8306 29.0431 54.5977 29.1812 54.4424C29.3192 54.2699 29.5003 54.1836 29.7246 54.1836H46.2612C46.4855 54.1836 46.6667 54.2612 46.8047 54.4165C46.9427 54.5718 47.0117 54.8047 47.0117 55.1152V59.5405C47.0117 59.8511 46.9427 60.084 46.8047 60.2393C46.6667 60.3945 46.4855 60.4722 46.2612 60.4722H41.4478V89.0942C41.4478 89.3875 41.3701 89.6118 41.2148 89.7671C41.0768 89.9224 40.9043 90 40.6973 90H35.2886C35.0643 90 34.8831 89.9224 34.7451 89.7671C34.6071 89.6118 34.5381 89.3875 34.5381 89.0942V60.4722H29.7246C29.5003 60.4722 29.3192 60.3945 29.1812 60.2393C29.0431 60.084 28.9741 59.8511 28.9741 59.5405V55.1411ZM67.9478 88.8872C67.9478 89.1287 67.8787 89.3703 67.7407 89.6118C67.6027 89.8534 67.3612 89.9741 67.0161 89.9741H62.2544C61.9611 89.9741 61.6851 89.8792 61.4263 89.6895C61.1847 89.4997 61.064 89.2064 61.064 88.8096V83.4009C61.064 80.8993 60.6154 79.0877 59.7183 77.9663C58.8211 76.8276 57.484 76.1979 55.707 76.0771V89.0425C55.707 89.6808 55.4224 90 54.853 90H49.6772C49.1079 90 48.8232 89.6808 48.8232 89.0425V55.1929C48.8232 54.8823 48.9009 54.6408 49.0562 54.4683C49.2114 54.2785 49.4271 54.1836 49.7031 54.1836H58.8384C60.1668 54.1836 61.4004 54.4338 62.5391 54.9341C63.6777 55.4172 64.6611 56.0814 65.4893 56.9268C66.3346 57.7721 66.9902 58.7642 67.4561 59.9028C67.9391 61.0243 68.1807 62.2319 68.1807 63.5259V67.2266C68.1807 68.0029 68.0858 68.7189 67.896 69.3745C67.7062 70.0129 67.4474 70.6081 67.1196 71.1602C66.7918 71.695 66.395 72.1867 65.9292 72.6353C65.4806 73.0838 64.9976 73.4806 64.48 73.8257C65.6359 74.8091 66.4985 76.1462 67.0679 77.8369C67.6545 79.5104 67.9478 81.6411 67.9478 84.229V88.8872ZM55.707 60.4722V70.7461H58.1138C59.1489 70.7461 59.9339 70.4787 60.4688 69.9438C61.0036 69.409 61.271 68.7017 61.271 67.8218V63.5259C61.271 62.5942 60.995 61.8524 60.4429 61.3003C59.908 60.7482 59.1921 60.4722 58.2949 60.4722H55.707ZM78.1182 81.2012C78.1182 81.6152 78.1785 82.012 78.2993 82.3916C78.4201 82.7539 78.6012 83.0817 78.8428 83.375C79.0843 83.6683 79.369 83.9012 79.6968 84.0737C80.0418 84.2463 80.4386 84.3325 80.8872 84.3325C81.3185 84.3325 81.7067 84.2463 82.0518 84.0737C82.3968 83.9012 82.6815 83.6683 82.9058 83.375C83.1473 83.0817 83.3285 82.7539 83.4492 82.3916C83.57 82.012 83.6304 81.6152 83.6304 81.2012V55.2188C83.6304 54.9427 83.6994 54.7012 83.8374 54.4941C83.9754 54.2871 84.1825 54.1836 84.4585 54.1836H89.7119C90.0052 54.1836 90.2122 54.2957 90.333 54.52C90.471 54.7271 90.54 54.96 90.54 55.2188V81.5894C90.54 82.8315 90.2726 83.9961 89.7378 85.083C89.2202 86.1699 88.5215 87.1274 87.6416 87.9556C86.7617 88.7664 85.7352 89.4048 84.562 89.8706C83.3888 90.3364 82.1553 90.5693 80.8613 90.5693C79.5674 90.5693 78.3338 90.3364 77.1606 89.8706C76.0047 89.4048 74.9782 88.7664 74.0811 87.9556C73.2012 87.1274 72.5024 86.1699 71.9849 85.083C71.4673 83.9961 71.2085 82.8315 71.2085 81.5894V55.1929C71.2085 54.9168 71.2689 54.6839 71.3896 54.4941C71.5277 54.2871 71.6916 54.1836 71.8813 54.1836H77.3418C77.6523 54.1836 77.8594 54.2871 77.9629 54.4941C78.0664 54.6839 78.1182 54.9168 78.1182 55.1929V81.2012ZM100.374 81.2012C100.374 81.6152 100.434 82.012 100.555 82.3916C100.693 82.7539 100.883 83.0817 101.125 83.375C101.366 83.6683 101.659 83.9012 102.004 84.0737C102.349 84.2463 102.746 84.3325 103.195 84.3325C103.661 84.3325 104.066 84.2463 104.411 84.0737C104.773 83.9012 105.067 83.6683 105.291 83.375C105.533 83.0817 105.705 82.7539 105.809 82.3916C105.929 82.012 105.99 81.6152 105.99 81.2012V78.1216C105.99 77.7248 106.042 77.4574 106.145 77.3193C106.266 77.1813 106.473 77.1123 106.766 77.1123H111.605C111.899 77.1123 112.114 77.1727 112.252 77.2935C112.39 77.4142 112.459 77.673 112.459 78.0698V81.5894C112.459 82.9868 112.218 84.2463 111.735 85.3677C111.252 86.4718 110.588 87.4121 109.742 88.1885C108.897 88.9648 107.905 89.5601 106.766 89.9741C105.645 90.3709 104.437 90.5693 103.143 90.5693C101.849 90.5693 100.616 90.3709 99.4424 89.9741C98.2692 89.5601 97.2427 88.9648 96.3628 88.1885C95.4829 87.4121 94.7842 86.4718 94.2666 85.3677C93.749 84.2463 93.4902 82.9868 93.4902 81.5894V62.6201C93.4902 61.3434 93.7231 60.1616 94.189 59.0747C94.672 57.9705 95.3363 57.0216 96.1816 56.228C97.0443 55.4172 98.0622 54.7874 99.2354 54.3389C100.426 53.873 101.728 53.6401 103.143 53.6401C104.713 53.6401 106.076 53.9076 107.232 54.4424C108.388 54.96 109.337 55.6501 110.079 56.5127C110.838 57.3581 111.398 58.3242 111.761 59.4111C112.123 60.498 112.304 61.6108 112.304 62.7495V65.2598C112.304 65.6566 112.252 65.9499 112.149 66.1396C112.045 66.3122 111.821 66.3984 111.476 66.3984H106.663C106.352 66.3984 106.136 66.3208 106.016 66.1655C105.912 65.993 105.86 65.7256 105.86 65.3633V62.9565C105.86 62.577 105.8 62.2061 105.679 61.8438C105.558 61.4642 105.386 61.1278 105.162 60.8345C104.937 60.5412 104.661 60.3083 104.333 60.1357C104.006 59.946 103.626 59.8511 103.195 59.8511C102.781 59.8511 102.393 59.9373 102.03 60.1099C101.685 60.2651 101.392 60.4894 101.15 60.7827C100.909 61.0588 100.719 61.3779 100.581 61.7402C100.443 62.1025 100.374 62.4907 100.374 62.9048V81.2012ZM115.332 55.1929C115.332 54.8823 115.401 54.6408 115.539 54.4683C115.694 54.2785 115.919 54.1836 116.212 54.1836H121.362C121.655 54.1836 121.871 54.2785 122.009 54.4683C122.147 54.6408 122.216 54.8823 122.216 55.1929V68.9346C123.285 68.8483 124.174 68.5981 124.881 68.1841C125.589 67.77 126.149 67.2266 126.563 66.5537C126.995 65.8809 127.297 65.0872 127.469 64.1729C127.642 63.2585 127.728 62.2578 127.728 61.1709V55.374C127.728 54.9772 127.849 54.6839 128.09 54.4941C128.349 54.2871 128.625 54.1836 128.918 54.1836H133.706C134.051 54.1836 134.293 54.313 134.431 54.5718C134.569 54.8133 134.638 55.0549 134.638 55.2964V61.9473C134.638 64.1556 134.258 66.1051 133.499 67.7959C132.74 69.4694 131.67 70.8755 130.29 72.0142C131.791 73.1528 132.947 74.5934 133.758 76.3359C134.586 78.0612 135 80.0798 135 82.3916V88.9131C135 89.1546 134.931 89.3962 134.793 89.6377C134.655 89.8792 134.413 90 134.068 90H129.255C128.962 90 128.694 89.9051 128.453 89.7153C128.211 89.5256 128.09 89.2323 128.09 88.8354V83.1938C128.09 82.0724 127.995 81.0459 127.806 80.1143C127.633 79.1826 127.314 78.3804 126.848 77.7075C126.4 77.0347 125.796 76.4998 125.037 76.103C124.295 75.7062 123.354 75.4819 122.216 75.4302V89.0166C122.216 89.6722 121.94 90 121.388 90H116.212C115.625 90 115.332 89.6722 115.332 89.0166V55.1929ZM138.054 55.1929C138.054 54.8823 138.131 54.6408 138.287 54.4683C138.442 54.2785 138.658 54.1836 138.934 54.1836H154.409C154.892 54.1836 155.134 54.5028 155.134 55.1411V59.5405C155.134 60.1616 154.892 60.4722 154.409 60.4722H144.938V68.7793H152.494C152.718 68.7793 152.908 68.8483 153.063 68.9863C153.236 69.1243 153.322 69.3573 153.322 69.6851V74.1104C153.322 74.4209 153.245 74.6452 153.089 74.7832C152.934 74.9212 152.736 74.9902 152.494 74.9902H144.938V83.7632H154.539C154.746 83.7632 154.918 83.8408 155.056 83.9961C155.211 84.1341 155.289 84.3498 155.289 84.6431V89.0942C155.289 89.4048 155.211 89.6377 155.056 89.793C154.918 89.931 154.746 90 154.539 90H138.934C138.347 90 138.054 89.6722 138.054 89.0166V55.1929ZM176.898 88.8872C176.898 89.1287 176.829 89.3703 176.691 89.6118C176.553 89.8534 176.311 89.9741 175.966 89.9741H171.205C170.911 89.9741 170.635 89.8792 170.376 89.6895C170.135 89.4997 170.014 89.2064 170.014 88.8096V83.4009C170.014 80.8993 169.566 79.0877 168.668 77.9663C167.771 76.8276 166.434 76.1979 164.657 76.0771V89.0425C164.657 89.6808 164.373 90 163.803 90H158.627C158.058 90 157.773 89.6808 157.773 89.0425V55.1929C157.773 54.8823 157.851 54.6408 158.006 54.4683C158.162 54.2785 158.377 54.1836 158.653 54.1836H167.789C169.117 54.1836 170.351 54.4338 171.489 54.9341C172.628 55.4172 173.611 56.0814 174.439 56.9268C175.285 57.7721 175.94 58.7642 176.406 59.9028C176.889 61.0243 177.131 62.2319 177.131 63.5259V67.2266C177.131 68.0029 177.036 68.7189 176.846 69.3745C176.656 70.0129 176.398 70.6081 176.07 71.1602C175.742 71.695 175.345 72.1867 174.879 72.6353C174.431 73.0838 173.948 73.4806 173.43 73.8257C174.586 74.8091 175.449 76.1462 176.018 77.8369C176.605 79.5104 176.898 81.6411 176.898 84.229V88.8872ZM164.657 60.4722V70.7461H167.064C168.099 70.7461 168.884 70.4787 169.419 69.9438C169.954 69.409 170.221 68.7017 170.221 67.8218V63.5259C170.221 62.5942 169.945 61.8524 169.393 61.3003C168.858 60.7482 168.142 60.4722 167.245 60.4722H164.657Z",
    fill: "#2DA5DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.714 81.2012C198.714 81.6152 198.774 82.012 198.895 82.3916C199.033 82.7539 199.223 83.0817 199.464 83.375C199.706 83.6683 199.999 83.9012 200.344 84.0737C200.689 84.2463 201.086 84.3325 201.535 84.3325C202 84.3325 202.406 84.2463 202.751 84.0737C203.113 83.9012 203.407 83.6683 203.631 83.375C203.872 83.0817 204.045 82.7539 204.148 82.3916C204.269 82.012 204.33 81.6152 204.33 81.2012V78.1216C204.33 77.7248 204.381 77.4574 204.485 77.3193C204.606 77.1813 204.813 77.1123 205.106 77.1123H209.945C210.239 77.1123 210.454 77.1727 210.592 77.2935C210.73 77.4142 210.799 77.673 210.799 78.0698V81.5894C210.799 82.9868 210.558 84.2463 210.075 85.3677C209.592 86.4718 208.927 87.4121 208.082 88.1885C207.237 88.9648 206.245 89.5601 205.106 89.9741C203.985 90.3709 202.777 90.5693 201.483 90.5693C200.189 90.5693 198.955 90.3709 197.782 89.9741C196.609 89.5601 195.583 88.9648 194.703 88.1885C193.823 87.4121 193.124 86.4718 192.606 85.3677C192.089 84.2463 191.83 82.9868 191.83 81.5894V62.6201C191.83 61.3434 192.063 60.1616 192.529 59.0747C193.012 57.9705 193.676 57.0216 194.521 56.228C195.384 55.4172 196.402 54.7874 197.575 54.3389C198.766 53.873 200.068 53.6401 201.483 53.6401C203.053 53.6401 204.416 53.9076 205.572 54.4424C206.728 54.96 207.677 55.6501 208.418 56.5127C209.178 57.3581 209.738 58.3242 210.101 59.4111C210.463 60.498 210.644 61.6108 210.644 62.7495V65.2598C210.644 65.6566 210.592 65.9499 210.489 66.1396C210.385 66.3122 210.161 66.3984 209.816 66.3984H205.002C204.692 66.3984 204.476 66.3208 204.355 66.1655C204.252 65.993 204.2 65.7256 204.2 65.3633V62.9565C204.2 62.577 204.14 62.2061 204.019 61.8438C203.898 61.4642 203.726 61.1278 203.501 60.8345C203.277 60.5412 203.001 60.3083 202.673 60.1357C202.346 59.946 201.966 59.8511 201.535 59.8511C201.121 59.8511 200.732 59.9373 200.37 60.1099C200.025 60.2651 199.732 60.4894 199.49 60.7827C199.249 61.0588 199.059 61.3779 198.921 61.7402C198.783 62.1025 198.714 62.4907 198.714 62.9048V81.2012ZM213.672 55.1929C213.672 54.8823 213.741 54.6408 213.879 54.4683C214.034 54.2785 214.25 54.1836 214.526 54.1836H219.702C219.995 54.1836 220.211 54.2785 220.349 54.4683C220.487 54.6408 220.556 54.8823 220.556 55.1929V89.0166C220.556 89.6722 220.271 90 219.702 90H214.526C213.957 90 213.672 89.6722 213.672 89.0166V55.1929ZM243.458 88.8872C243.458 89.1287 243.389 89.3703 243.251 89.6118C243.113 89.8534 242.872 89.9741 242.527 89.9741H237.765C237.472 89.9741 237.196 89.8792 236.937 89.6895C236.695 89.4997 236.575 89.2064 236.575 88.8096V83.4009C236.575 80.8993 236.126 79.0877 235.229 77.9663C234.332 76.8276 232.995 76.1979 231.218 76.0771V89.0425C231.218 89.6808 230.933 90 230.364 90H225.188C224.619 90 224.334 89.6808 224.334 89.0425V55.1929C224.334 54.8823 224.412 54.6408 224.567 54.4683C224.722 54.2785 224.938 54.1836 225.214 54.1836H234.349C235.678 54.1836 236.911 54.4338 238.05 54.9341C239.188 55.4172 240.172 56.0814 241 56.9268C241.845 57.7721 242.501 58.7642 242.967 59.9028C243.45 61.0243 243.691 62.2319 243.691 63.5259V67.2266C243.691 68.0029 243.597 68.7189 243.407 69.3745C243.217 70.0129 242.958 70.6081 242.63 71.1602C242.303 71.695 241.906 72.1867 241.44 72.6353C240.991 73.0838 240.508 73.4806 239.991 73.8257C241.147 74.8091 242.009 76.1462 242.579 77.8369C243.165 79.5104 243.458 81.6411 243.458 84.229V88.8872ZM231.218 60.4722V70.7461H233.625C234.66 70.7461 235.445 70.4787 235.979 69.9438C236.514 69.409 236.782 68.7017 236.782 67.8218V63.5259C236.782 62.5942 236.506 61.8524 235.954 61.3003C235.419 60.7482 234.703 60.4722 233.806 60.4722H231.218ZM253.267 81.2012C253.267 81.6152 253.327 82.012 253.448 82.3916C253.586 82.7539 253.776 83.0817 254.017 83.375C254.259 83.6683 254.552 83.9012 254.897 84.0737C255.242 84.2463 255.639 84.3325 256.087 84.3325C256.553 84.3325 256.959 84.2463 257.304 84.0737C257.666 83.9012 257.959 83.6683 258.184 83.375C258.425 83.0817 258.598 82.7539 258.701 82.3916C258.822 82.012 258.882 81.6152 258.882 81.2012V78.1216C258.882 77.7248 258.934 77.4574 259.038 77.3193C259.158 77.1813 259.365 77.1123 259.659 77.1123H264.498C264.791 77.1123 265.007 77.1727 265.145 77.2935C265.283 77.4142 265.352 77.673 265.352 78.0698V81.5894C265.352 82.9868 265.111 84.2463 264.627 85.3677C264.144 86.4718 263.48 87.4121 262.635 88.1885C261.789 88.9648 260.797 89.5601 259.659 89.9741C258.537 90.3709 257.33 90.5693 256.036 90.5693C254.742 90.5693 253.508 90.3709 252.335 89.9741C251.162 89.5601 250.135 88.9648 249.255 88.1885C248.375 87.4121 247.677 86.4718 247.159 85.3677C246.642 84.2463 246.383 82.9868 246.383 81.5894V62.6201C246.383 61.3434 246.616 60.1616 247.082 59.0747C247.565 57.9705 248.229 57.0216 249.074 56.228C249.937 55.4172 250.955 54.7874 252.128 54.3389C253.318 53.873 254.621 53.6401 256.036 53.6401C257.606 53.6401 258.969 53.9076 260.125 54.4424C261.28 54.96 262.229 55.6501 262.971 56.5127C263.73 57.3581 264.291 58.3242 264.653 59.4111C265.016 60.498 265.197 61.6108 265.197 62.7495V65.2598C265.197 65.6566 265.145 65.9499 265.042 66.1396C264.938 66.3122 264.714 66.3984 264.369 66.3984H259.555C259.245 66.3984 259.029 66.3208 258.908 66.1655C258.805 65.993 258.753 65.7256 258.753 65.3633V62.9565C258.753 62.577 258.693 62.2061 258.572 61.8438C258.451 61.4642 258.278 61.1278 258.054 60.8345C257.83 60.5412 257.554 60.3083 257.226 60.1357C256.898 59.946 256.519 59.8511 256.087 59.8511C255.673 59.8511 255.285 59.9373 254.923 60.1099C254.578 60.2651 254.285 60.4894 254.043 60.7827C253.801 61.0588 253.612 61.3779 253.474 61.7402C253.336 62.1025 253.267 62.4907 253.267 62.9048V81.2012ZM268.225 55.1929C268.225 54.8823 268.294 54.6408 268.432 54.4683C268.57 54.2785 268.785 54.1836 269.079 54.1836H274.254C274.548 54.1836 274.763 54.2785 274.901 54.4683C275.039 54.6408 275.108 54.8823 275.108 55.1929V83.7632H283.855C284.339 83.7632 284.58 84.0565 284.58 84.6431V89.0684C284.58 89.6895 284.339 90 283.855 90H269.104C268.518 90 268.225 89.6722 268.225 89.0166V55.1929ZM287.013 55.1929C287.013 54.8823 287.09 54.6408 287.246 54.4683C287.401 54.2785 287.617 54.1836 287.893 54.1836H303.368C303.851 54.1836 304.093 54.5028 304.093 55.1411V59.5405C304.093 60.1616 303.851 60.4722 303.368 60.4722H293.896V68.7793H301.453C301.677 68.7793 301.867 68.8483 302.022 68.9863C302.195 69.1243 302.281 69.3573 302.281 69.6851V74.1104C302.281 74.4209 302.204 74.6452 302.048 74.7832C301.893 74.9212 301.695 74.9902 301.453 74.9902H293.896V83.7632H303.498C303.705 83.7632 303.877 83.8408 304.015 83.9961C304.17 84.1341 304.248 84.3498 304.248 84.6431V89.0942C304.248 89.4048 304.17 89.6377 304.015 89.793C303.877 89.931 303.705 90 303.498 90H287.893C287.306 90 287.013 89.6722 287.013 89.0166V55.1929Z",
    fill: "#0078B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 91.4482H63.9902V91.6105H64.3148V91.4482Z",
    fill: "#2DA5DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 99.5615H63.9902V99.886H64.3148V99.5615Z",
    fill: "#2DA5DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 113.76H63.9902V114.084H64.3148V113.76Z",
    fill: "#2DA5DE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 105.403H63.9902V105.728H64.3148V105.403Z",
    fill: "#2DA5DE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 104.592H63.9902V104.916H64.3148V104.592Z",
    fill: "#2DA5DE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 107.106H63.9902V107.431H64.3148V107.106Z",
    fill: "#2DA5DE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 103.78H63.9902V104.105H64.3148V103.78Z",
    fill: "#2DA5DE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 111.245H63.9902V111.57H64.3148V111.245Z",
    fill: "#2DA5DE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 107.918H63.9902V108.243H64.3148V107.918Z",
    fill: "#2DA5DE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 110.434H63.9902V110.758H64.3148V110.434Z",
    fill: "#2DA5DE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 112.056H63.9902V112.38H64.3148V112.056Z",
    fill: "#2DA5DE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 112.867H63.9902V113.192H64.3148V112.867Z",
    fill: "#2DA5DE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 108.729H63.9902V109.054H64.3148V108.729Z",
    fill: "#2DA5DE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 109.541H63.9902V109.866H64.3148V109.541Z",
    fill: "#2DA5DE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 95.4238H63.9902V95.7484H64.3148V95.4238Z",
    fill: "#2DA5DE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 96.2354H63.9902V96.5599H64.3148V96.2354Z",
    fill: "#2DA5DE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 114.571H63.9902V114.896H64.3148V114.571Z",
    fill: "#2DA5DE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 97.1279H63.9902V97.4525H64.3148V97.1279Z",
    fill: "#2DA5DE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 97.9385H63.9902V98.263H64.3148V97.9385Z",
    fill: "#2DA5DE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 102.888H63.9902V103.212H64.3148V102.888Z",
    fill: "#2DA5DE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 94.6123H63.9902V94.9368H64.3148V94.6123Z",
    fill: "#2DA5DE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 98.75H63.9902V99.0745H64.3148V98.75Z",
    fill: "#2DA5DE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 100.453H63.9902V100.778H64.3148V100.453Z",
    fill: "#2DA5DE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 101.265H63.9902V101.589H64.3148V101.265Z",
    fill: "#2DA5DE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 102.076H63.9902V102.401H64.3148V102.076Z",
    fill: "#2DA5DE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 93.8018H63.9902V94.1263H64.3148V93.8018Z",
    fill: "#2DA5DE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 92.9082H63.9902V93.2327H64.3148V92.9082Z",
    fill: "#2DA5DE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 92.0967H63.9902V92.4212H64.3148V92.0967Z",
    fill: "#2DA5DE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 106.215H63.9902V106.539H64.3148V106.215Z",
    fill: "#2DA5DE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3148 115.382H63.9902V115.544H64.3148V115.382Z",
    fill: "#2DA5DE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 95.9102H66.5059V96.0724H66.8304V95.9102Z",
    fill: "#2DA5DE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 99.9668H66.5059V100.291H66.8304V99.9668Z",
    fill: "#2DA5DE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 100.778H66.5059V101.103H66.8304V100.778Z",
    fill: "#2DA5DE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 101.671H66.5059V101.995H66.8304V101.671Z",
    fill: "#2DA5DE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 102.481H66.5059V102.806H66.8304V102.481Z",
    fill: "#2DA5DE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 103.293H66.5059V103.618H66.8304V103.293Z",
    fill: "#2DA5DE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 98.2637H66.5059V98.5882H66.8304V98.2637Z",
    fill: "#2DA5DE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 96.5596H66.5059V96.8841H66.8304V96.5596Z",
    fill: "#2DA5DE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 97.4521H66.5059V97.7767H66.8304V97.4521Z",
    fill: "#2DA5DE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 99.1562H66.5059V99.4808H66.8304V99.1562Z",
    fill: "#2DA5DE"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 107.513H66.5059V107.837H66.8304V107.513Z",
    fill: "#2DA5DE"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 110.108H66.5059V110.433H66.8304V110.108Z",
    fill: "#2DA5DE"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 108.405H66.5059V108.73H66.8304V108.405Z",
    fill: "#2DA5DE"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 109.217H66.5059V109.541H66.8304V109.217Z",
    fill: "#2DA5DE"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 104.187H66.5059V104.511H66.8304V104.187Z",
    fill: "#2DA5DE"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 106.701H66.5059V107.026H66.8304V106.701Z",
    fill: "#2DA5DE"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 104.997H66.5059V105.322H66.8304V104.997Z",
    fill: "#2DA5DE"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 105.89H66.5059V106.214H66.8304V105.89Z",
    fill: "#2DA5DE"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8304 110.92H66.5059V111.082H66.8304V110.92Z",
    fill: "#2DA5DE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 95.9102H79.0811V96.0724H79.4056V95.9102Z",
    fill: "#2DA5DE"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 100.778H79.0811V101.103H79.4056V100.778Z",
    fill: "#2DA5DE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 102.481H79.0811V102.806H79.4056V102.481Z",
    fill: "#2DA5DE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 101.671H79.0811V101.995H79.4056V101.671Z",
    fill: "#2DA5DE"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 103.293H79.0811V103.618H79.4056V103.293Z",
    fill: "#2DA5DE"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 97.4521H79.0811V97.7767H79.4056V97.4521Z",
    fill: "#2DA5DE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 99.1562H79.0811V99.4808H79.4056V99.1562Z",
    fill: "#2DA5DE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 98.2637H79.0811V98.5882H79.4056V98.2637Z",
    fill: "#2DA5DE"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 99.9668H79.0811V100.291H79.4056V99.9668Z",
    fill: "#2DA5DE"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 108.405H79.0811V108.73H79.4056V108.405Z",
    fill: "#2DA5DE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 109.217H79.0811V109.541H79.4056V109.217Z",
    fill: "#2DA5DE"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 110.108H79.0811V110.433H79.4056V110.108Z",
    fill: "#2DA5DE"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 107.513H79.0811V107.837H79.4056V107.513Z",
    fill: "#2DA5DE"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 106.701H79.0811V107.026H79.4056V106.701Z",
    fill: "#2DA5DE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 104.187H79.0811V104.511H79.4056V104.187Z",
    fill: "#2DA5DE"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 104.997H79.0811V105.322H79.4056V104.997Z",
    fill: "#2DA5DE"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 105.89H79.0811V106.214H79.4056V105.89Z",
    fill: "#2DA5DE"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 96.5596H79.0811V96.8841H79.4056V96.5596Z",
    fill: "#2DA5DE"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4056 110.92H79.0811V111.082H79.4056V110.92Z",
    fill: "#2DA5DE"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 95.9102H86.626V96.0724H86.9505V95.9102Z",
    fill: "#2DA5DE"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 103.293H86.626V103.618H86.9505V103.293Z",
    fill: "#2DA5DE"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 97.4521H86.626V97.7767H86.9505V97.4521Z",
    fill: "#2DA5DE"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 99.1562H86.626V99.4808H86.9505V99.1562Z",
    fill: "#2DA5DE"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 96.5596H86.626V96.8841H86.9505V96.5596Z",
    fill: "#2DA5DE"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 99.9668H86.626V100.291H86.9505V99.9668Z",
    fill: "#2DA5DE"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 100.778H86.626V101.103H86.9505V100.778Z",
    fill: "#2DA5DE"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 102.481H86.626V102.806H86.9505V102.481Z",
    fill: "#2DA5DE"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 101.671H86.626V101.995H86.9505V101.671Z",
    fill: "#2DA5DE"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 98.2637H86.626V98.5882H86.9505V98.2637Z",
    fill: "#2DA5DE"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 110.108H86.626V110.433H86.9505V110.108Z",
    fill: "#2DA5DE"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 107.513H86.626V107.837H86.9505V107.513Z",
    fill: "#2DA5DE"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 108.405H86.626V108.73H86.9505V108.405Z",
    fill: "#2DA5DE"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 109.217H86.626V109.541H86.9505V109.217Z",
    fill: "#2DA5DE"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 105.89H86.626V106.214H86.9505V105.89Z",
    fill: "#2DA5DE"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 106.701H86.626V107.026H86.9505V106.701Z",
    fill: "#2DA5DE"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 104.997H86.626V105.322H86.9505V104.997Z",
    fill: "#2DA5DE"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 104.187H86.626V104.511H86.9505V104.187Z",
    fill: "#2DA5DE"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9505 110.92H86.626V111.082H86.9505V110.92Z",
    fill: "#2DA5DE"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 94.4502H58.96V94.6125H59.2845V94.4502Z",
    fill: "#2DA5DE"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 102.481H58.96V102.806H59.2845V102.481Z",
    fill: "#2DA5DE"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 100.048H58.96V100.372H59.2845V100.048Z",
    fill: "#2DA5DE"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 99.2363H58.96V99.5609H59.2845V99.2363Z",
    fill: "#2DA5DE"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 100.859H58.96V101.184H59.2845V100.859Z",
    fill: "#2DA5DE"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 101.671H58.96V101.995H59.2845V101.671Z",
    fill: "#2DA5DE"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 98.3447H58.96V98.6693H59.2845V98.3447Z",
    fill: "#2DA5DE"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 96.7217H58.96V97.0462H59.2845V96.7217Z",
    fill: "#2DA5DE"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 109.946H58.96V110.271H59.2845V109.946Z",
    fill: "#2DA5DE"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 97.5332H58.96V97.8577H59.2845V97.5332Z",
    fill: "#2DA5DE"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 111.568H58.96V111.893H59.2845V111.568Z",
    fill: "#2DA5DE"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 110.758H58.96V111.082H59.2845V110.758Z",
    fill: "#2DA5DE"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 105.809H58.96V106.133H59.2845V105.809Z",
    fill: "#2DA5DE"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 107.432H58.96V107.756H59.2845V107.432Z",
    fill: "#2DA5DE"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 108.323H58.96V108.648H59.2845V108.323Z",
    fill: "#2DA5DE"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 109.135H58.96V109.459H59.2845V109.135Z",
    fill: "#2DA5DE"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 104.997H58.96V105.322H59.2845V104.997Z",
    fill: "#2DA5DE"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 106.62H58.96V106.945H59.2845V106.62Z",
    fill: "#2DA5DE"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 95.9102H58.96V96.2347H59.2845V95.9102Z",
    fill: "#2DA5DE"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 103.375H58.96V103.7H59.2845V103.375Z",
    fill: "#2DA5DE"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 104.187H58.96V104.511H59.2845V104.187Z",
    fill: "#2DA5DE"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 95.0996H58.96V95.4241H59.2845V95.0996Z",
    fill: "#2DA5DE"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2845 112.462H58.96V112.624H59.2845V112.462Z",
    fill: "#2DA5DE"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 92.584H81.5967V92.7462H81.9212V92.584Z",
    fill: "#2DA5DE"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 99.9668H81.5967V100.291H81.9212V99.9668Z",
    fill: "#2DA5DE"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 107.513H81.5967V107.837H81.9212V107.513Z",
    fill: "#2DA5DE"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 108.323H81.5967V108.648H81.9212V108.323Z",
    fill: "#2DA5DE"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 109.217H81.5967V109.541H81.9212V109.217Z",
    fill: "#2DA5DE"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 106.701H81.5967V107.026H81.9212V106.701Z",
    fill: "#2DA5DE"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 105.809H81.5967V106.133H81.9212V105.809Z",
    fill: "#2DA5DE"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 110.027H81.5967V110.352H81.9212V110.027Z",
    fill: "#2DA5DE"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 104.997H81.5967V105.322H81.9212V104.997Z",
    fill: "#2DA5DE"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 113.354H81.5967V113.678H81.9212V113.354Z",
    fill: "#2DA5DE"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 94.125H81.5967V94.4495H81.9212V94.125Z",
    fill: "#2DA5DE"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 94.9365H81.5967V95.2611H81.9212V94.9365Z",
    fill: "#2DA5DE"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 112.543H81.5967V112.867H81.9212V112.543Z",
    fill: "#2DA5DE"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 111.731H81.5967V112.056H81.9212V111.731Z",
    fill: "#2DA5DE"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 110.839H81.5967V111.163H81.9212V110.839Z",
    fill: "#2DA5DE"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 93.2334H81.5967V93.5579H81.9212V93.2334Z",
    fill: "#2DA5DE"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 100.778H81.5967V101.103H81.9212V100.778Z",
    fill: "#2DA5DE"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 101.671H81.5967V101.995H81.9212V101.671Z",
    fill: "#2DA5DE"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 95.748H81.5967V96.0726H81.9212V95.748Z",
    fill: "#2DA5DE"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 99.1562H81.5967V99.4808H81.9212V99.1562Z",
    fill: "#2DA5DE"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 102.481H81.5967V102.806H81.9212V102.481Z",
    fill: "#2DA5DE"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 97.4521H81.5967V97.7767H81.9212V97.4521Z",
    fill: "#2DA5DE"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 98.2637H81.5967V98.5882H81.9212V98.2637Z",
    fill: "#2DA5DE"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 104.187H81.5967V104.511H81.9212V104.187Z",
    fill: "#2DA5DE"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 96.6406H81.5967V96.9652H81.9212V96.6406Z",
    fill: "#2DA5DE"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 103.293H81.5967V103.618H81.9212V103.293Z",
    fill: "#2DA5DE"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9212 114.246H81.5967V114.408H81.9212V114.246Z",
    fill: "#2DA5DE"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 98.75H61.4756V98.9123H61.8001V98.75Z",
    fill: "#2DA5DE"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 102.076H61.4756V102.401H61.8001V102.076Z",
    fill: "#2DA5DE"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 101.185H61.4756V101.59H61.8001V101.185Z",
    fill: "#2DA5DE"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 102.888H61.4756V103.212H61.8001V102.888Z",
    fill: "#2DA5DE"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 104.592H61.4756V104.916H61.8001V104.592Z",
    fill: "#2DA5DE"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 99.4805H61.4756V99.805H61.8001V99.4805Z",
    fill: "#2DA5DE"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 103.78H61.4756V104.105H61.8001V103.78Z",
    fill: "#2DA5DE"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 100.292H61.4756V100.698H61.8001V100.292Z",
    fill: "#2DA5DE"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 105.484H61.4756V105.809H61.8001V105.484Z",
    fill: "#2DA5DE"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 107.188H61.4756V107.594H61.8001V107.188Z",
    fill: "#2DA5DE"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 106.377H61.4756V106.783H61.8001V106.377Z",
    fill: "#2DA5DE"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 108.08H61.4756V108.242H61.8001V108.08Z",
    fill: "#2DA5DE"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8909 98.75H76.5664V98.9123H76.8909V98.75Z",
    fill: "#2DA5DE"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8909 106.377H76.5664V106.783H76.8909V106.377Z",
    fill: "#2DA5DE"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8909 105.484H76.5664V105.809H76.8909V105.484Z",
    fill: "#2DA5DE"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8909 107.188H76.5664V107.594H76.8909V107.188Z",
    fill: "#2DA5DE"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8909 104.592H76.5664V104.916H76.8909V104.592Z",
    fill: "#2DA5DE"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8909 102.888H76.5664V103.212H76.8909V102.888Z",
    fill: "#2DA5DE"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8909 102.076H76.5664V102.401H76.8909V102.076Z",
    fill: "#2DA5DE"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8909 103.78H76.5664V104.105H76.8909V103.78Z",
    fill: "#2DA5DE"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8909 99.4805H76.5664V99.805H76.8909V99.4805Z",
    fill: "#2DA5DE"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8909 101.185H76.5664V101.59H76.8909V101.185Z",
    fill: "#2DA5DE"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8909 100.292H76.5664V100.698H76.8909V100.292Z",
    fill: "#2DA5DE"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8909 108.08H76.5664V108.242H76.8909V108.08Z",
    fill: "#2DA5DE"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8607 101.671H71.5361V101.833H71.8607V101.671Z",
    fill: "#2DA5DE"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8607 104.267H71.5361V104.672H71.8607V104.267Z",
    fill: "#2DA5DE"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8607 102.401H71.5361V102.807H71.8607V102.401Z",
    fill: "#2DA5DE"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8607 103.293H71.5361V103.699H71.8607V103.293Z",
    fill: "#2DA5DE"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8607 105.16H71.5361V105.322H71.8607V105.16Z",
    fill: "#2DA5DE"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3753 102.807H74.0508V102.969H74.3753V102.807Z",
    fill: "#2DA5DE"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3753 103.375H74.0508V103.618H74.3753V103.375Z",
    fill: "#2DA5DE"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3753 104.023H74.0508V104.186H74.3753V104.023Z",
    fill: "#2DA5DE"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M69.346 100.697H69.0215V100.86H69.346V100.697Z",
    fill: "#2DA5DE"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M69.346 101.347H69.0215V101.671H69.346V101.347Z",
    fill: "#2DA5DE"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M69.346 102.158H69.0215V102.483H69.346V102.158Z",
    fill: "#2DA5DE"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M69.346 104.592H69.0215V104.916H69.346V104.592Z",
    fill: "#2DA5DE"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M69.346 105.403H69.0215V105.728H69.346V105.403Z",
    fill: "#2DA5DE"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M69.346 102.969H69.0215V103.293H69.346V102.969Z",
    fill: "#2DA5DE"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M69.346 103.78H69.0215V104.105H69.346V103.78Z",
    fill: "#2DA5DE"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M69.346 106.133H69.0215V106.295H69.346V106.133Z",
    fill: "#2DA5DE"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4661 100.697H89.1416V100.86H89.4661V100.697Z",
    fill: "#2DA5DE"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4661 105.403H89.1416V105.728H89.4661V105.403Z",
    fill: "#2DA5DE"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4661 103.78H89.1416V104.105H89.4661V103.78Z",
    fill: "#2DA5DE"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4661 104.592H89.1416V104.916H89.4661V104.592Z",
    fill: "#2DA5DE"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4661 102.969H89.1416V103.293H89.4661V102.969Z",
    fill: "#2DA5DE"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4661 101.347H89.1416V101.671H89.4661V101.347Z",
    fill: "#2DA5DE"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4661 102.158H89.1416V102.483H89.4661V102.158Z",
    fill: "#2DA5DE"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4661 106.133H89.1416V106.295H89.4661V106.133Z",
    fill: "#2DA5DE"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7698 100.697H56.4453V100.86H56.7698V100.697Z",
    fill: "#2DA5DE"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7698 102.158H56.4453V102.483H56.7698V102.158Z",
    fill: "#2DA5DE"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7698 105.403H56.4453V105.728H56.7698V105.403Z",
    fill: "#2DA5DE"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7698 103.78H56.4453V104.105H56.7698V103.78Z",
    fill: "#2DA5DE"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7698 102.969H56.4453V103.293H56.7698V102.969Z",
    fill: "#2DA5DE"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7698 104.592H56.4453V104.916H56.7698V104.592Z",
    fill: "#2DA5DE"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7698 101.347H56.4453V101.671H56.7698V101.347Z",
    fill: "#2DA5DE"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7698 106.133H56.4453V106.295H56.7698V106.133Z",
    fill: "#2DA5DE"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2542 99.9668H53.9297V100.129H54.2542V99.9668Z",
    fill: "#2DA5DE"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2542 103.293H53.9297V103.699H54.2542V103.293Z",
    fill: "#2DA5DE"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2542 105.078H53.9297V105.484H54.2542V105.078Z",
    fill: "#2DA5DE"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2542 105.972H53.9297V106.377H54.2542V105.972Z",
    fill: "#2DA5DE"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2542 101.509H53.9297V101.914H54.2542V101.509Z",
    fill: "#2DA5DE"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2542 100.616H53.9297V101.022H54.2542V100.616Z",
    fill: "#2DA5DE"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2542 104.187H53.9297V104.592H54.2542V104.187Z",
    fill: "#2DA5DE"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2542 102.401H53.9297V102.807H54.2542V102.401Z",
    fill: "#2DA5DE"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2542 106.863H53.9297V107.026H54.2542V106.863Z",
    fill: "#2DA5DE"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4359 99.3994H84.1113V99.5617H84.4359V99.3994Z",
    fill: "#2DA5DE"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4359 103.375H84.1113V103.7H84.4359V103.375Z",
    fill: "#2DA5DE"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4359 102.563H84.1113V102.888H84.4359V102.563Z",
    fill: "#2DA5DE"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4359 104.187H84.1113V104.511H84.4359V104.187Z",
    fill: "#2DA5DE"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4359 104.997H84.1113V105.322H84.4359V104.997Z",
    fill: "#2DA5DE"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4359 105.809H84.1113V106.133H84.4359V105.809Z",
    fill: "#2DA5DE"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4359 106.62H84.1113V106.945H84.4359V106.62Z",
    fill: "#2DA5DE"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4359 100.048H84.1113V100.372H84.4359V100.048Z",
    fill: "#2DA5DE"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4359 100.859H84.1113V101.184H84.4359V100.859Z",
    fill: "#2DA5DE"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4359 101.671H84.1113V101.995H84.4359V101.671Z",
    fill: "#2DA5DE"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4359 107.432H84.1113V107.594H84.4359V107.432Z",
    fill: "#2DA5DE"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7396 102.563H51.415V102.726H51.7396V102.563Z",
    fill: "#2DA5DE"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7397 103.293V103.699H51.4152V103.618H51.2529V103.374H51.4152V103.293H51.7397Z",
    fill: "#2DA5DE"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7396 104.267H51.415V104.429H51.7396V104.267Z",
    fill: "#2DA5DE"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9808 102.563H91.6562V102.726H91.9808V102.563Z",
    fill: "#2DA5DE"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0619 103.374V103.618V103.699H91.6562V103.293H92.0619V103.374Z",
    fill: "#2DA5DE"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9808 104.267H91.6562V104.429H91.9808V104.267Z",
    fill: "#2DA5DE"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4863 103.537H36.6486V103.456L36.4863 103.537Z",
    fill: "#2DA5DE"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1357 103.537H37.3791V103.456H37.1357V103.537Z",
    fill: "#2DA5DE"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8662 103.537H38.0285V103.456H37.8662V103.537Z",
    fill: "#2DA5DE"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8401 103.456H38.5967V103.537H38.8401V103.456Z",
    fill: "#2DA5DE"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4885 103.456V103.537H39.2451V103.456H39.4885Z",
    fill: "#2DA5DE"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M40.219 103.456H39.9756V103.537H40.219V103.456Z",
    fill: "#2DA5DE"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8683 103.456V103.537H40.7061V103.456H40.8683Z",
    fill: "#2DA5DE"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5979 103.456H41.3545V103.537H41.5979V103.456Z",
    fill: "#2DA5DE"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3284 103.456V103.537H42.085V103.456H42.3284Z",
    fill: "#2DA5DE"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0578 103.456H42.8145V103.537H43.0578V103.456Z",
    fill: "#2DA5DE"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7082 103.456H43.4648V103.537H43.7082V103.456Z",
    fill: "#2DA5DE"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4377 103.456H44.1943V103.537H44.4377V103.456Z",
    fill: "#2DA5DE"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1682 103.456H44.9248V103.618H45.1682V103.456Z",
    fill: "#2DA5DE"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8166 103.456V103.537H45.5732V103.456H45.8166Z",
    fill: "#2DA5DE"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5471 103.456H46.3037V103.618H46.5471V103.456Z",
    fill: "#2DA5DE"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2776 103.456H47.0342V103.618H47.2776V103.456Z",
    fill: "#2DA5DE"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M47.926 103.456H47.6826V103.618H47.926V103.456Z",
    fill: "#2DA5DE"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6565 103.456V103.618H48.4131V103.456H48.6565Z",
    fill: "#2DA5DE"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M49.387 103.456H49.1436V103.618H49.387V103.456Z",
    fill: "#2DA5DE"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0364 103.375H49.793V103.537H50.0364V103.375Z",
    fill: "#2DA5DE"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7659 103.375H50.5225V103.537H50.7659V103.375Z",
    fill: "#2DA5DE"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7932 103.375V103.618H92.5498V103.375H92.7932Z",
    fill: "#2DA5DE"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5227 103.375H93.2793V103.537H93.5227V103.375Z",
    fill: "#2DA5DE"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1711 103.456H93.9277V103.618H94.1711V103.456Z",
    fill: "#2DA5DE"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9016 103.456H94.6582V103.618H94.9016V103.456Z",
    fill: "#2DA5DE"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6321 103.456H95.3887V103.618H95.6321V103.456Z",
    fill: "#2DA5DE"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2815 103.456V103.618H96.0381V103.456H96.2815Z",
    fill: "#2DA5DE"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M97.011 103.456H96.7676V103.618H97.011V103.456Z",
    fill: "#2DA5DE"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6603 103.456V103.537H97.498V103.456H97.6603Z",
    fill: "#2DA5DE"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3899 103.456H98.1465V103.618H98.3899V103.456Z",
    fill: "#2DA5DE"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1213 103.456V103.537H98.8779V103.456H99.1213Z",
    fill: "#2DA5DE"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8508 103.456H99.6074V103.537H99.8508V103.456Z",
    fill: "#2DA5DE"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 103.456H100.257V103.537H100.5V103.456Z",
    fill: "#2DA5DE"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M101.23 103.456H100.986V103.537H101.23V103.456Z",
    fill: "#2DA5DE"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M101.96 103.456H101.717V103.537H101.96V103.456Z",
    fill: "#2DA5DE"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M102.366 103.537H102.61V103.456H102.366V103.537Z",
    fill: "#2DA5DE"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M103.097 103.537H103.34V103.456H103.097V103.537Z",
    fill: "#2DA5DE"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M103.826 103.537H103.988V103.456H103.826V103.537Z",
    fill: "#2DA5DE"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M104.557 103.537H104.719V103.456H104.557V103.537Z",
    fill: "#2DA5DE"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M105.206 103.537H105.449V103.456H105.206V103.537Z",
    fill: "#2DA5DE"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M105.937 103.537H106.099V103.456H105.937V103.537Z",
    fill: "#2DA5DE"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M106.666 103.537H106.828V103.456H106.666V103.537Z",
    fill: "#2DA5DE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoblue);
export default __webpack_public_path__ + "static/media/logoblue.a37bae7bbca1b9d5442a6e84da6e95ac.svg";
export { ForwardRef as ReactComponent };